import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'dateFormat'
})
export class DateFormat implements PipeTransform {
    transform(value: any, args: string[]): any {
        if (value) {
            const date = value instanceof Date ? value : new Date(value);
            return moment(date).format('DD/MM/YYYY');
        }
    }
}
